import {colors} from 'shells/colors/colors';
import {Illustration} from 'shells/illustrations/illustration';
import {ImageWrapper} from 'shells/onboarding-modal/image-wrapper';

const size = 280;

type PageIndex = 'Introduction' | 'BeforeYouConnect' | 'Connect' | 'Connected' | 'SyncConfirmation';

function getImage(pageIndex: PageIndex) {
    switch (pageIndex) {
        case 'Introduction':
            return <Illustration src='nutshell-whatsapp-stars' width={size} />;
        case 'BeforeYouConnect':
            return <Illustration src='person-with-stop-hand' width={size} />;
        case 'SyncConfirmation':
            return <Illustration src='high-five' width={size} />;
        case 'Connect':
        case 'Connected':
        default:
            return (
                <Illustration
                    src='whatsapp-logo-with-title'
                    width={size}
                    fullPath='/include/images/whatsapp-logo-with-title.png'
                />
            );
    }
}

export function getArt(pageIndex: PageIndex) {
    return {
        background: colors.plumLt,
        image: () => <ImageWrapper image={getImage(pageIndex)} width={size} />,
    };
}
